export default __webpack_public_path__ + "static/media/june2023.766a258b.png";